import { SimpleTable } from 'Foundation/Common/SimpleTable';
import { useUserData } from 'Foundation/User/UserContext';
import { isProd } from 'Foundation/Configurations/GlobalConfiguration';
import { Heading } from '@lmig/lmds-react-typography';
import { ExpandableCard } from '@lmig/lmds-react-card';

export function AgentInfo() {
  const { userData } = useUserData();

  return (
    <>
      {userData && (
              <ExpandableCard
                cardTitle={<Heading type="h4-light">Agent Info</Heading>}
                style={{ marginBottom: '0px' }}
              >
                      <SimpleTable
                        tableObject={[
                          { name: 'Name', value: userData.name },
                          { name: userData.isBL() ? 'LDAP ID' : 'DPEC ID', value: userData.dpecid },
                          { name: 'User Type', value: userData.userType },
                          {
                            name: 'User ID',
                            value:
                              isProd() && (userData.isAgent() || userData.isMockingAgent)
                                ? userData.userIdNoAuthSuffix()
                                : userData.userId,
                          },
                          { name: 'Channel', value: userData.channel },
                          { name: 'State', value: userData.state },
                          { name: 'Classification', value: userData.classification },
                        ]}
                        nameProp="name"
                        valueProp="value"
                      /></ExpandableCard>                              
         
      )}
    </>
  );
}
